
import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';
let defaultForm = {
  tplCarrierCode: '',
  tplServiceCode: '',
  carrierCode: '',
  serviceCode: '',
  rateWeightUnit: 'LBS'
};

let defaultFilters = {
  tplCarrierCode: '',
  tplServiceCode: '',
  carrierCode: '',
  serviceCode: '',
  rateWeightUnit: '',
  brandId: ''
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state,
    tableOptions: {
      ...genedStore.state.tableOptions
    }
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  }
};
